var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"threejsContainer"},[_c('div',{staticClass:"containerTitle"},[_vm._v("1-3.着色器 顶点着色器-涟漪-半屏(单场景、双相机、双渲染器)")]),_c('div',{ref:"container1",staticClass:"containerHalfBody"}),_c('div',{ref:"container2",staticClass:"containerHalfBody"})])
}
var staticRenderFns = []

export { render, staticRenderFns }